<template>
    <div
        class="text-center"
        :class="{
            'w-100': fullWidth,
            'h-100': fullHeight,
            'd-flex': imageCenter,
        }"
    >
        <template v-if="url.length && !loading">
            <img
                v-if="isImage"
                class="img-fluid"
                :class="{
                    'm-auto': imageCenter,
                    [imgClass]: !!imgClass,
                }"
                :src="url"
                :alt="file.name || file.title || file.fileName || $t('name not found')"
            />
            <iframe
                v-else
                :src="url"
                width="100%"
                height="100%"
                style="min-height: 500px"
            ></iframe>
        </template>
        <Loader v-else />
    </div>
</template>

<script>
import { FilesService } from '@services/files-v2.service';
import { isImageExtensionByName } from '@services/helper.service';

import Loader from '@components/Loader';

export default {
    name: 'BaseFilePreview',

    components: { Loader },

    props: {
        file: {
            validator: (prop) => typeof prop === 'object' || prop === null,
            required: true,
        },
        fullWidth: Boolean,
        fullHeight: Boolean,
        imageCenter: Boolean,
        imgClass: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            url: '',
            loading: false,
        };
    },

    computed: {
        isImage() {
            return isImageExtensionByName(this.file.name);
        },
    },

    watch: {
        file: {
            immediate: true,
            async handler() {
                try {
                    this.loading = true;
                    await this.getUrl();
                } finally {
                    this.loading = false;
                }
            },
        },
    },

    methods: {
        async getUrl(tries = 0) {
            return FilesService.get(this.file.id)
                .then((response) => {
                    if (response.data.type === 'image/svg') {
                        const blob = new Blob([response.data], { type: 'image/svg+xml' });
                        this.url = URL.createObjectURL(blob);
                    } else {
                        this.url = URL.createObjectURL(response.data);
                    }
                })
                .catch(() => {
                    if (tries < 3) {
                        setTimeout(() => {
                            return this.getUrl(++tries);
                        }, 500);
                    }
                });
        },
    },
};
</script>

<style scoped></style>
